import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetAssetsBrandValidationMetadataQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
  assetIds: Array<Types.Scalars['ID']['input']>;
  first: Types.Scalars['NonNegativeInt']['input'];
}>;


export type GetAssetsBrandValidationMetadataQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, assets?: { __typename?: 'AssetConnection', nodes: Array<{ __typename: 'AudioAsset', id: string, name: string } | { __typename: 'DocumentAsset', id: string, name: string } | { __typename: 'FileAsset', id: string, name: string } | { __typename: 'FolderAsset', id: string, name: string } | { __typename: 'ImageAsset', id: string, name: string, media?: { __typename?: 'ImageMedia', id: string, mimeType?: string | null } | null } | { __typename: 'InteractiveAsset', id: string, name: string } | { __typename: 'InteractiveLiveAsset', id: string, name: string } | { __typename: 'ModelAsset', id: string, name: string } | { __typename: 'UnsupportedAsset', id: string, name: string } | { __typename: 'VersionStackAsset', id: string, name: string } | { __typename: 'VideoAsset', id: string, name: string }> } | null } | null };


export const GetAssetsBrandValidationMetadata = /*#__PURE__*/ gql`
    query GetAssetsBrandValidationMetadata($accountId: ID!, $assetIds: [ID!]!, $first: NonNegativeInt!) {
  account(by: {id: $accountId}) {
    id
    assets(assetIds: $assetIds, page: {first: $first}) {
      nodes {
        id
        name
        __typename
        ... on ImageAsset {
          media {
            id
            mimeType
          }
        }
      }
    }
  }
}
    ` as unknown as DocumentNode<GetAssetsBrandValidationMetadataQuery, GetAssetsBrandValidationMetadataQueryVariables>;

          

          export const useGetAssetsBrandValidationMetadataQuery = (options?:QueryHookOptions<GetAssetsBrandValidationMetadataQuery, GetAssetsBrandValidationMetadataQueryVariables>) => useQuery(GetAssetsBrandValidationMetadata, options);

          

          export type GetAssetsBrandValidationMetadataQueryOptions = QueryHookOptions<GetAssetsBrandValidationMetadataQuery, GetAssetsBrandValidationMetadataQueryVariables>;

          

          export const useGetAssetsBrandValidationMetadataLazyQuery = (options?:LazyQueryHookOptions<GetAssetsBrandValidationMetadataQuery, GetAssetsBrandValidationMetadataQueryVariables>) => useLazyQuery(GetAssetsBrandValidationMetadata, options);

          

          export type GetAssetsBrandValidationMetadataQueryResult = ReturnType<typeof useGetAssetsBrandValidationMetadataQuery>;

          
